import { useQuery } from '@tanstack/react-query';

import getTalkingPointDetail from 'Api/brief-live/getTalkingPointDetail';
import getTalkingPointDetailResponse from './model/response/getTalkingPointDetailResponse';

const useGetTalkingPointDetail = (id) => {
  return useQuery({
    queryKey: ['talking-point', id],
    queryFn: async () => {
      const response = await getTalkingPointDetail(id);
      return getTalkingPointDetailResponse(response);
    },
    enabled: !!id,
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetTalkingPointDetail;
